import { render, staticRenderFns } from "./ExpirationReport.vue?vue&type=template&id=f351fddc"
import script from "./ExpirationReport.vue?vue&type=script&lang=js"
export * from "./ExpirationReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports